export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=68439f18&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/promotions/index.vue?vue&type=template&id=68439f18&
// module id = 1100
// module chunks = 0